import { ComponentPropsWithoutRef, FC } from 'react';

export const ProfileHeightXlIcon: FC<ComponentPropsWithoutRef<'svg'>> = (props) => (
  <svg width="256" height="400" viewBox="0 0 256 400" fill="none" {...props}>
    <g clipPath="url(#clip0_3109_67916)">
      <path
        d="M194 75.436C194 108.092 170.948 134.56 142.512 134.56C114.076 134.56 91.0161 108.092 91.0161 75.436"
        fill="black"
      />
      <path d="M101.942 47V88.3481H143.257C143.264 65.5129 124.767 47 101.942 47Z" fill="black" />
      <path d="M101.942 59.2451V88.348H131.021C131.021 72.2747 118.002 59.2451 101.942 59.2451Z" fill="#1B1F2C" />
      <path
        d="M144.503 143.275C168.004 143.275 187.055 124.208 187.055 100.688C187.055 77.1672 168.004 58.1001 144.503 58.1001C121.002 58.1001 101.95 77.1672 101.95 100.688C101.95 124.208 121.002 143.275 144.503 143.275Z"
        fill="black"
      />
      <path d="M184.814 47V88.3481H143.5C143.5 65.5129 161.997 47 184.814 47Z" fill="black" />
      <path
        d="M139.126 105.394C141.723 105.394 143.829 103.287 143.829 100.687C143.829 98.0877 141.723 95.9805 139.126 95.9805C136.529 95.9805 134.423 98.0877 134.423 100.687C134.423 103.287 136.529 105.394 139.126 105.394Z"
        fill="#2AD8D8"
      />
      <path
        d="M168.989 105.394C171.586 105.394 173.692 103.287 173.692 100.687C173.692 98.0877 171.586 95.9805 168.989 95.9805C166.392 95.9805 164.286 98.0877 164.286 100.687C164.286 103.287 166.392 105.394 168.989 105.394Z"
        fill="#2AD8D8"
      />
      <path
        d="M159.434 106.665C159.434 109.638 157.028 112.046 154.058 112.046C151.087 112.046 148.681 109.638 148.681 106.665"
        fill="#4EC3F7"
      />
      <path
        d="M135.317 247.935C122.321 249.645 108.707 245.504 98.7289 235.518C81.6812 218.456 81.6812 190.804 98.7289 173.743C107.249 165.216 107.249 151.386 98.7289 142.851C90.209 134.324 76.3906 134.324 67.8628 142.851"
        stroke="black"
        strokeWidth="14.96"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path d="M95.335 395.458L139.087 237.526" stroke="black" strokeWidth="14.96" strokeMiterlimit="10" />
      <path d="M154.677 397.702L159.811 237.526" stroke="black" strokeWidth="14.96" strokeMiterlimit="10" />
      <path
        d="M145.992 255.443C158.909 255.443 169.381 244.963 169.381 232.035C169.381 219.107 158.909 208.627 145.992 208.627C133.075 208.627 122.604 219.107 122.604 232.035C122.604 244.963 133.075 255.443 145.992 255.443Z"
        fill="black"
      />
      <path
        d="M145.804 240.821C144.597 240.821 143.367 240.672 142.144 240.358C134.251 238.342 129.478 230.301 131.492 222.402C139.636 190.467 131.586 158.242 131.5 157.921C129.446 150.029 134.18 141.981 142.066 139.926C149.951 137.87 158.016 142.616 160.069 150.516C160.485 152.116 170.157 190.201 160.085 229.713C158.384 236.389 152.38 240.836 145.796 240.836L145.804 240.821Z"
        fill="black"
      />
      <path
        d="M104.435 383.77C95.4763 383.77 88.2183 391.034 88.2183 400H104.435H120.652L104.435 383.77Z"
        fill="#443A60"
      />
      <path d="M88.2183 395.944V400H104.435H120.652L116.6 395.944H88.2183Z" fill="black" />
      <path
        d="M162.005 383.77C153.047 383.77 145.789 391.034 145.789 400H162.005H178.222L162.005 383.77Z"
        fill="#443A60"
      />
      <path d="M145.789 395.944V400H162.005H178.222L174.17 395.944H145.789Z" fill="black" />
      <path
        d="M163.33 212.549C163.73 209.435 164.028 206.36 164.239 203.348H134.635C134.376 206.368 134.016 209.443 133.514 212.549H163.33Z"
        fill="#2AD8D8"
      />
      <path
        d="M138.327 149.464L107.084 185.431L133.169 217.295"
        stroke="black"
        strokeWidth="15.06"
        strokeMiterlimit="10"
      />
    </g>
    <defs>
      <clipPath id="clip0_3109_67916">
        <rect width="132" height="353" fill="white" transform="translate(62 47)" />
      </clipPath>
    </defs>
  </svg>
);
